import React from 'react';
import { RemoteConfig } from 'firebase/remote-config';
import { CommunicationBanner } from './CommunicationBanner';
import './styles.scss';
import { useRemoteConfig } from '../../hooks';
import { Banner } from './types';
import { isValidBanner } from './utils';

const BannerKeys = {
  business: 'business_banner',
  technical: 'technical_banner',
};

interface Props {
  remoteConfig: RemoteConfig;
}

export const CommunicationBanners = ({ remoteConfig }: Props) => {
  const businessBanner = useRemoteConfig<Banner>(
    remoteConfig,
    BannerKeys.business,
  );
  const technicalBanner = useRemoteConfig<Banner>(
    remoteConfig,
    BannerKeys.technical,
  );

  return (
    <>
      {isValidBanner(businessBanner) && (
        <CommunicationBanner banner={businessBanner as Banner} />
      )}
      {isValidBanner(technicalBanner) && (
        <CommunicationBanner banner={technicalBanner as Banner} />
      )}
    </>
  );
};
